import React from 'react';
import Button from '@material-ui/core/Button';

export default function SaveButton({ label = 'Save', ...other }) {
  return (
    <Button
      data-cy="admin-form--submit-button"
      data-testid="save"
      variant="contained"
      color="secondary"
      {...other}
    >
      {label}
    </Button>
  );
}
